import template from './operation-types.html';
import controller from './operation-types.controller';

let operationTypesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default operationTypesComponent;
